<script setup>
import { useClientStore } from "@/store/client";
const Magasin = defineAsyncComponent(() =>import("@/components/organisms/mise-en-avant-corapro/magasin"));
const Services = defineAsyncComponent(() =>import("@/components/organisms/mise-en-avant-corapro/services"));

const props = defineProps({
  magasin: {
    type: Object,
    required: false,
    default: null
  },
  isFicheMagasin:  {
    type: Boolean,
    required: false,
    default: false
  }
});

const component = computed(() => {
  return props.isFicheMagasin ? Magasin : Services
})

const {
  client,
  isPro,
  canCheckoutProInMagasin
} = storeToRefs(useClientStore());

const contact = computed(() => {
  return props.magasin.attributes && 
  props.magasin.attributes.infos_corapro && 
  props.magasin.attributes.infos_corapro[0] ? props.magasin.attributes.infos_corapro[0] : null
})

</script>
<template>
  <component
    :is="component"
    :is-pro="isPro"
    :client-name="client && client.attributes ? client.attributes.name : null"
    :magasin="magasin"
    :contact="contact"
  />
</template>
